/* eslint-disable @typescript-eslint/naming-convention */

export enum TransportCategory {
    Outbox = "Outbox",
    Send = "Send",
    Polling = "Polling"
}

export class TransportType {
    Id: number;
    Name: string;
    Description: string;
    Direction: string;
    TransportType: TransportCategory;
    IsSystemTransportType: boolean;
    ArtifactId: string;
    TransportKey: string;
    CreatedDate: Date;
    CreatedBy: number;
    UpdatedDate: Date;
    UpdatedBy: number;
}

export interface TransportTypeArtifactInfo {
    TransportType: TransportCategory;
    TransportKey: string;
}
